import moment from 'moment'

const timeHelper = {
  getOffsetDayByWeek: function (week, offset = 0, year = null) {
    if (!year) {
      year = this.getCurrentYear()
    }
    let dt = moment()
    dt.set('year', year)
    dt.set('week', week)
    dt.set('weekday', offset)
    return {
      day: dt.format('D'),
      month: dt.format('MMMM'),
      info: {
        day: dt.format('D'),
        year: year,
        month: dt.format('M'),
        week: week
      },
      dayOfMonth: dt.format('D MMMM')
    }
  },
  getCurrentYear: function () {
    return +(new Date()).getFullYear()
  },
  getMonthByWeek: function (week, year = null) {
    if (!year) {
      year = this.getCurrentYear()
    }
    let dt = moment()
    dt.set('year', year)
    dt.set('week', week)
    return {
      id: dt.format('MM'),
      name: dt.format('MMMM')
    }
  },
  getCurrentWeek: function () {
    return moment().isoWeek()
  }
}

export default timeHelper
